export const env = {
  env: "release",
  graphql: {
    uri: "https://api.rvhub.com.br/graphql",
    clientId: "76g4bqh33hsmfs33665n1ta5fh",
    clientSecret: "1qn1v1513ekkblk2otrnr3l61pi153tqe4b0med0toe84a2jbvqk",
  },
  take: {
    whatsapp: {
      url: "https://api.whatsapp.com/send?phone=552140042627",
      text: {
        signUp: "&text=J%C3%A1%20fiz%20o%20meu%20cadastro",
        login: "&text=Sim",
      },
    },
  },
};
